/* eslint-disable @typescript-eslint/no-var-requires */
import appointment from './es/appointment';
import browserSupport from './es/browserSupport';
import deviceCheck from './es/deviceCheck';
import deviceIssue from './es/deviceIssue';
import generalFaq from './es/generalFaq';
import microphoneFaq from './es/microphoneFaq';
import cameraFaq from './es/cameraFaq';
import speakerFaq from './es/speakerFaq';
import permissionDenied from './es/permissionDenied';
import waitingRoom from './es/waitingRoom';
import technicalIssue from './es/technicalIssue';
import deviceSettings from './es/deviceSettings';
import videoCall from './es/videoCall';
import footer from './es/footer';
import fullFaq from './es/fullFaq';
import controlBar from './es/controlBar';
import telehealthDeviceFaqIntro from './es/telehealthDeviceFaqIntro';
import testingStrings from './es/testingStrings';
import chat from './es/chat';
import termsConditions from './es/termsConditions';
import optumTermsAndConditions from './es/optumTermsAndConditions';

interface LangKeyValuesType {
  [prop: string]: { [prop: string]: string };
}

const langKeyValues: LangKeyValuesType = {
  GENERAL: {
    ...appointment,
    ...browserSupport,
    ...deviceCheck,
    ...generalFaq,
    ...permissionDenied,
    ...deviceIssue,
    ...footer,
    ...fullFaq,
    ...termsConditions,
    ...optumTermsAndConditions,
  },
  DEVICE_FAQ: {
    ...microphoneFaq,
    ...cameraFaq,
    ...speakerFaq,
    ...telehealthDeviceFaqIntro,
    ...testingStrings,
  },
  WAITING_ROOM: {
    ...waitingRoom,
  },
  TECHNICAL_ISSUE: {
    ...technicalIssue,
  },
  DEVICE_SETTINGS: {
    ...deviceSettings,
  },
  VIDEO_CALL: {
    ...videoCall,
  },
  CONTROL_BAR: {
    ...controlBar,
  },
  CHAT: {
    ...chat,
  },
};

export default langKeyValues;
